<template>
  <md-radio class="md-radio" :model="checked ? value : ''" :value="value" @change="handleChange" :disabled="disabled">{{
    label
  }}</md-radio>
</template>

<script>
export default {
  name: "MuiRadio",
  props: {
    value: {
      type: [String, Number, Boolean],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.md-radio {
  // 动画不支持，所以隐藏动画，否则会造成元素闪显闪隐
  ::v-deep .md-ripple {
    display: none;
  }

  &.md-checked {
    ::v-deep .md-radio-container {
      border-color: $success !important;

      &::after {
        background-color: $success !important;
      }
    }
  }
}
</style>
